import React from 'react';
import {getContrastColor} from '../../../common/helpers';
import PropTypes from 'prop-types';
//Mui
import {Paper, Typography} from '@mui/material';

import {makeStyles} from 'tss-react/mui';

const GroupBoxColor = ({
   //Props sobre el titulo
   title,
   bgColorTitleEnable,
   bgColorTitle,
   titlePosition,
   borderColorTitle,
   borderColorTitleEnable,
   //Props sobre el paper
   borderColorPaper,
   borderSize,
   bgColorPaper,
   borderRadiusPaper,

   children
}) => {
   let borderColorControlPaper = '#000000';
   if (borderColorPaper) {
      borderColorControlPaper = borderColorPaper;
   }

   let bgColorControlTitle = '#000000';
   if (bgColorTitle) {
      bgColorControlTitle = bgColorTitle;
   } else {
      bgColorControlTitle = bgColorTitleEnable ? borderColorControlPaper : '#ffffff';
   }

   console.log(bgColorControlTitle);

   let borderColorControlTitle = '';
   if (borderColorTitle) {
      borderColorControlTitle = borderColorTitle;
   } else {
      borderColorControlTitle = borderColorTitleEnable ? borderColorControlPaper : 'none';
   }

   const useGroupBox = makeStyles()(() => ({
      paper: {
         borderRadius: borderRadiusPaper + 'px',
         padding: '20px 20px',
         marginBottom: '1.45rem',
         width: '100%',
         position: 'relative',
         border: borderSize + 'px solid ' + borderColorControlPaper,
         backgroundColor: bgColorPaper || '#aaa',
         color: bgColorPaper ? getContrastColor(bgColorPaper) : 'black'
      },
      title: {
         position: 'absolute',
         padding: '0 10px',
         borderRadius: '10px',
         backgroundColor: bgColorControlTitle,
         color: getContrastColor(bgColorControlTitle),
         border: '1px solid ' + borderColorControlTitle
      },
      titleTopLeft: {
         top: '-10px',
         left: '40px'
      },
      titleTopRight: {
         top: '-10px',
         right: '40px'
      },
      titleBottonRight: {
         bottom: '-10px',
         right: '40px'
      },
      titleBottonLeft: {
         bottom: '-10px',
         left: '40px'
      }
   }));

   const {classes, cx} = useGroupBox();

   return (
      <Paper className={cx(classes.paper)}>
         <Typography
            variant="h6"
            className={cx(classes.title, {
               [classes.titleTopLeft]: titlePosition === 'TopL',
               [classes.titleTopRight]: titlePosition === 'TopR',
               [classes.titleBottonLeft]: titlePosition === 'BottonL',
               [classes.titleBottonRight]: titlePosition === 'BottonR'
            })}
         >
            {title}
         </Typography>
         {children}
      </Paper>
   );
};

GroupBoxColor.propTypes = {
   //Props sobre el titulo
   title: PropTypes.string,
   bgColorTitle: PropTypes.string,
   titlePosition: PropTypes.oneOf(['TopL', 'TopR', 'BottonR', 'BottonL']),
   bgColorTitleEnable: PropTypes.bool,
   borderColorTitleEnable: PropTypes.bool,
   //Props sobre Paper
   borderColorPaper: PropTypes.string,
   borderSize: PropTypes.number,
   bgColorPaper: PropTypes.string
};

GroupBoxColor.defaultProps = {
   //Props sobre el titulo
   title: 'Titulo',
   bgColorTitleEnable: false,
   bgColorTitle: '',
   titlePosition: 'TopR',
   borderColorTitle: '',
   borderColorTitleEnable: false,
   //Props sobre Paper
   borderColorPaper: '#000000',
   bgColorPaper: '',
   borderRadiusPaper: 30,
   borderSize: 1
};

export default GroupBoxColor;
